import styled from 'styled-components';
import { Checkbox } from 'semantic-ui-react';

const CustomCheckbox = styled(Checkbox)`
  &&& {
    margin-left: 30px;
  }
`;

const CategoryContainer = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export {
  CustomCheckbox,
  CategoryContainer,
};
